import _defineProperty from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// src/use-controllable-state.tsx
import * as React from "react";
import { useLayoutEffect } from "@radix-ui/react-use-layout-effect";
var useInsertionEffect = React[" useInsertionEffect ".trim().toString()] || useLayoutEffect;
function useControllableState(_ref) {
  var prop = _ref.prop,
    defaultProp = _ref.defaultProp,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    caller = _ref.caller;
  var _useUncontrolledState = useUncontrolledState({
      defaultProp: defaultProp,
      onChange: onChange
    }),
    _useUncontrolledState2 = _slicedToArray(_useUncontrolledState, 3),
    uncontrolledProp = _useUncontrolledState2[0],
    setUncontrolledProp = _useUncontrolledState2[1],
    onChangeRef = _useUncontrolledState2[2];
  var isControlled = prop !== void 0;
  var value = isControlled ? prop : uncontrolledProp;
  if (true) {
    var isControlledRef = React.useRef(prop !== void 0);
    React.useEffect(function () {
      var wasControlled = isControlledRef.current;
      if (wasControlled !== isControlled) {
        var from = wasControlled ? "controlled" : "uncontrolled";
        var to = isControlled ? "controlled" : "uncontrolled";
        console.warn("".concat(caller, " is changing from ").concat(from, " to ").concat(to, ". Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component."));
      }
      isControlledRef.current = isControlled;
    }, [isControlled, caller]);
  }
  var setValue = React.useCallback(function (nextValue) {
    if (isControlled) {
      var value2 = isFunction(nextValue) ? nextValue(prop) : nextValue;
      if (value2 !== prop) {
        var _onChangeRef$current;
        (_onChangeRef$current = onChangeRef.current) === null || _onChangeRef$current === void 0 || _onChangeRef$current.call(onChangeRef, value2);
      }
    } else {
      setUncontrolledProp(nextValue);
    }
  }, [isControlled, prop, setUncontrolledProp, onChangeRef]);
  return [value, setValue];
}
function useUncontrolledState(_ref2) {
  var defaultProp = _ref2.defaultProp,
    onChange = _ref2.onChange;
  var _React$useState = React.useState(defaultProp),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  var prevValueRef = React.useRef(value);
  var onChangeRef = React.useRef(onChange);
  useInsertionEffect(function () {
    onChangeRef.current = onChange;
  }, [onChange]);
  React.useEffect(function () {
    if (prevValueRef.current !== value) {
      var _onChangeRef$current2;
      (_onChangeRef$current2 = onChangeRef.current) === null || _onChangeRef$current2 === void 0 || _onChangeRef$current2.call(onChangeRef, value);
      prevValueRef.current = value;
    }
  }, [value, prevValueRef]);
  return [value, setValue, onChangeRef];
}
function isFunction(value) {
  return typeof value === "function";
}

// src/use-controllable-state-reducer.tsx
import * as React2 from "react";
import { useEffectEvent } from "@radix-ui/react-use-effect-event";
var SYNC_STATE = Symbol("RADIX:SYNC_STATE");
function useControllableStateReducer(reducer, userArgs, initialArg, init) {
  var controlledState = userArgs.prop,
    defaultProp = userArgs.defaultProp,
    onChangeProp = userArgs.onChange,
    caller = userArgs.caller;
  var isControlled = controlledState !== void 0;
  var onChange = useEffectEvent(onChangeProp);
  if (true) {
    var isControlledRef = React2.useRef(controlledState !== void 0);
    React2.useEffect(function () {
      var wasControlled = isControlledRef.current;
      if (wasControlled !== isControlled) {
        var from = wasControlled ? "controlled" : "uncontrolled";
        var to = isControlled ? "controlled" : "uncontrolled";
        console.warn("".concat(caller, " is changing from ").concat(from, " to ").concat(to, ". Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component."));
      }
      isControlledRef.current = isControlled;
    }, [isControlled, caller]);
  }
  var args = [_objectSpread(_objectSpread({}, initialArg), {}, {
    state: defaultProp
  })];
  if (init) {
    args.push(init);
  }
  var _React2$useReducer = React2.useReducer.apply(React2, [function (state2, action) {
      if (action.type === SYNC_STATE) {
        return _objectSpread(_objectSpread({}, state2), {}, {
          state: action.state
        });
      }
      var next = reducer(state2, action);
      if (isControlled && !Object.is(next.state, state2.state)) {
        onChange(next.state);
      }
      return next;
    }].concat(args)),
    _React2$useReducer2 = _slicedToArray(_React2$useReducer, 2),
    internalState = _React2$useReducer2[0],
    dispatch = _React2$useReducer2[1];
  var uncontrolledState = internalState.state;
  var prevValueRef = React2.useRef(uncontrolledState);
  React2.useEffect(function () {
    if (prevValueRef.current !== uncontrolledState) {
      prevValueRef.current = uncontrolledState;
      if (!isControlled) {
        onChange(uncontrolledState);
      }
    }
  }, [onChange, uncontrolledState, prevValueRef, isControlled]);
  var state = React2.useMemo(function () {
    var isControlled2 = controlledState !== void 0;
    if (isControlled2) {
      return _objectSpread(_objectSpread({}, internalState), {}, {
        state: controlledState
      });
    }
    return internalState;
  }, [internalState, controlledState]);
  React2.useEffect(function () {
    if (isControlled && !Object.is(controlledState, internalState.state)) {
      dispatch({
        type: SYNC_STATE,
        state: controlledState
      });
    }
  }, [controlledState, internalState.state, isControlled]);
  return [state, dispatch];
}
export { useControllableState, useControllableStateReducer };